import Cookies from 'js-cookie';
import { useEffect, useMemo, useRef, useState } from 'react';
// import MoeSoftAsk from "../../../src/components/MoeSoftAsk";
import { useRouter } from 'next/router';
import {
  b2G1_recover_key,
  recoveryDataKey,
} from '../../../src/Constants/AddressPage';
import { prefetchAndOpenCart } from '../../../src/Utils/CartUtils';
import { getUserIsLoggedIn } from '../../../src/Utils/helper';
import { MainContainer } from '../../../src/components/Product/PdpHeader/styled';
import Breadcrumbs from '../../../src/components/StoreCategoryPage/Breadcrumbs';
import { getSeoData } from '../../../src/components/StoreCategoryPage/common';
import { isDesktopUser } from '../../Utils/ProductUtils';
import PageLayout from '../PageLayout';
import { fireGeneralScreenEvent } from '../StoreCategoryPage/instrumentation';
import CategoryGeneralItemsListing from './CategoryGeneralItemListing';
import CategoryL2PageHead from './CategoryL2PageHead';
import ProductContainer from '../NewStoreHomeWeb/CategoryProductFilter/ProductContainer';
import { getGeneralItemByItemId } from '../../datafetchers/Store';

export default function CategoryL2Page(props) {
  const {
    categoryStaticData,
    categoryNavBarData,
    webUrl,
    breadCrumbsData,
    categoryId,
  } = props;
  const [addedToCart, setAddedToCart] = useState(false);
  const [generalItems, setGeneralItems] = useState([]);
  const bottomRef = useRef();
  const [wrapHeight, setWrapHeight] = useState(420);
  const [showHeader, setShowHeader] = useState('-56px');
  const filterRef = useRef();
  const throttleTimeout = useRef(false);
  const throttleTimeoutHeader = useRef(false);
  const oldScrollValue = useRef(0);
  const router = useRouter();
  const { items } = categoryStaticData?.data || {};
  const memoisedItems = useMemo(() => {
    const tabsData = [];
    items?.forEach((item, index) => {
      switch (item.itemType) {
        case 'MULTIPLE_ITEMS':
          tabsData.push(item);
          break;
      }
    });

    return {
      tabsData,
    };
  }, [categoryStaticData]);

  const { tabsData } = memoisedItems;

  const { metaTitle, metaDescription, openGraphData } = getSeoData(
    categoryStaticData,
    webUrl,
  );
  const categoryName = categoryStaticData?.data?.tabName;
  const faqsData = categoryStaticData?.data?.footNoteFaqs;
  const alsoSearchFor = categoryStaticData?.data?.alsoSearchFor;

  const footnoteData = categoryStaticData?.data?.footnote;

  const heading = categoryName;
  const htmlText = footnoteData;
  const priceTable = categoryStaticData?.data?.priceTable;
  const ratingTable = categoryStaticData?.data?.reviewTable;
  const updatedOn = categoryStaticData?.data?.lastUpdatedAtDate;

  useEffect(() => {
    setAddedToCart(false);
  }, [addedToCart]);

  const makeDynamicGeneralItems = async () => {
    const INTRO_OFFER_ITEM_ID = 6094;
    const data = await getGeneralItemByItemId(INTRO_OFFER_ITEM_ID);
    if (data) {
      setGeneralItems([data]);
    }
  };

  useEffect(() => {
    makeDynamicGeneralItems();
  }, []);

  const recoverDataFlow = async () => {
    const sku_ids = router.query[b2G1_recover_key];
    if (sku_ids && !Cookies.get(recoveryDataKey)) {
      Cookies.set('cart_items', sku_ids);
      prefetchAndOpenCart();
    }
  };
  useEffect(() => {
    if (!getUserIsLoggedIn()) recoverDataFlow();
  }, [router.query.sku_ids]);

  useEffect(() => {
    if (isDesktopUser()) {
      setShowHeader('0px');
    }

    function scrollUpOrDown() {
      if (!throttleTimeout.current) {
        setTimeout(() => {
          const offsetTop = filterRef.current?.getBoundingClientRect().top;
          if (
            (showHeader == '-56px' && offsetTop == 0) ||
            (showHeader != '-56px' && offsetTop == 65)
          ) {
            setWrapHeight(0);
          } else {
            setWrapHeight(420);
          }
          throttleTimeout.current = false;
        }, 100);
      }
      throttleTimeout.current = true;
      if (!throttleTimeoutHeader.current) {
        setTimeout(() => {
          let newValue = window.pageYOffset;
          // debugger;
          if (oldScrollValue.current < newValue) {
            //for Desktop screen
            if (newValue > 56) setShowHeader('-56px'); // for Mweb

            //on scroll down
          } else if (oldScrollValue.current > newValue) {
            // for Desktop screen
            setShowHeader('0px'); // for Mweb
            // on scroll up
          }
          oldScrollValue.current = newValue;
          throttleTimeoutHeader.current = false;
        }, 100);
      }
      throttleTimeoutHeader.current = true;
    }

    if (!isDesktopUser()) window.addEventListener('scroll', scrollUpOrDown);
    return () => {
      window.removeEventListener('scroll', scrollUpOrDown);
    };
  }, []);
  // const findCategory = () => {
  //     let tabName = "";
  //     subCategoriesData?.map((element) => {
  //         if (element?._id === categoryId) {
  //             tabName = element?.tabName;
  //         } else {
  //             element?.subCategories?.map((subCategories, index) => {
  //                 if (subCategories?._id === categoryId) {
  //                     tabName = element?.tabName;
  //                 }
  //             });
  //         }
  //     });
  //     return tabName;
  // };
  useEffect(() => {
    fireGeneralScreenEvent(webUrl, categoryStaticData?.data?.tabName, '');
  }, [categoryId]);
  const categoryUrl = categoryStaticData?.data?.webUrl;
  const categoryProducts = tabsData?.[0]?.items;

  const SEOData = {
    metaTitle,
    metaDescription,
    openGraphData,
    faqsData,
    breadCrumbsData,
    categoryUrl,
    categoryProducts,
    categoryId,
  };
  const footerObject = {
    heading,
    content: htmlText,
    webUrl,
    faqsData,
    priceTable,
    alsoSearchFor,
    bottomRef,
    ratingTable,
    updatedOn,
  };
  useEffect(() => {
    const insTags = document.querySelectorAll('ins');

    // Remove each <ins> element
    insTags?.forEach((ins) => ins?.remove());
    const googleAd = document.querySelector('#google-anno-sa');
    googleAd?.remove();
  }, []);
  const isL1Category = categoryStaticData?.data?.tabType === 'SHOP_CATEGORY';
  return (
    <>
      <CategoryL2PageHead {...SEOData} />
      <PageLayout
        categoryNavBarData={categoryNavBarData}
        footerObject={footerObject}
        showHeader={showHeader}
        location="category"
      >
        {breadCrumbsData?.length && (
          <Breadcrumbs
            breadCrumbs={breadCrumbsData}
            addClass={true}
            location={'category'}
          />
        )}

        <MainContainer
          showHeader={showHeader}
          paddingTop="0px"
          categ
          subCategory
          fullWidth
          noPadding
        >
          <CategoryGeneralItemsListing
            generalItems={categoryStaticData?.data?.items}
            categoryWrapHeight={wrapHeight}
            filterRef={filterRef}
            showHeader={showHeader}
            categoryId={categoryId}
            location="category"
            isL1Category={isL1Category}
            pageTitle={categoryStaticData?.data?.title}
            pageDesc={categoryStaticData?.data?.categoryDescription}
          />
          {generalItems?.length > 0 &&
            generalItems.map((element, index) => (
              <ProductContainer
                key={index}
                data={element}
                isForJoyfulPage={true}
                setChangeCartCount={props.setChangeCartCount}
                fitHeadingImage={true}
                fromCategoryPage={true}
              />
            ))}
        </MainContainer>
        {/* <BannerSection
                    installLink={
                        "https://app.mylofamily.com/get_mylo_app?source=organic&campaign=website_home_page"
                    }
                /> */}
      </PageLayout>
    </>
  );
}
